// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EtQ6","title":"styles_title__3wwJU"};